import React from "react";
import "./Header.less";
import clsx from "clsx";
import { Layout } from "antd";
import styles from "./Header.module.css";
import BetaBadge from "components/atoms/BetaBadge";

const { Header } = Layout;

/**
 * Page title bar. The account menu lives on the app sider now, so this is only the title
 * (and beta) for surfaces that still show a Header -- Ask does not.
 */
export default function LayoutHeader({ title, beta }) {
    return (
        <Header className={clsx(styles.header)}>
            <div className={clsx(styles.bar, "flex flex-col md:flex-row")}>
                <div className="flex items-center flex-grow" style={{ flexGrow: 1 }}>
                    <h1 className={styles.title}>{title}</h1>
                    {beta ? <BetaBadge className={styles.beta} /> : null}
                </div>
            </div>
        </Header>
    );
}
